module.exports = __webpack_public_path__ + "static/media/twitter.274cee16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/twitter.svg
// module id = 173
// module chunks = 0